import jwt_decode from 'jwt-decode';
import api from '../assets/js/api';

class AuthService {
    login(loginInfo) {
        return api
            .post('/admin/api/auth', {
                ...loginInfo,
            })
            .then(this.handleResponse)
            .then((response) => {
                if (response.data.accessToken) {
                    // localStorage.setItem('userInfo', JSON.stringify(response.data));
                    // 임시 값 하드코딩 : 2020.11.13, notbadlife
                    // let retParams = { ...response.data };
                    //
                    // // 실제 값이 전달될 경우 대체가능하도록 분기처리
                    // retParams.centerId = retParams.centerId === undefined ? 1 : retParams.centerId;
                    // retParams.userId = retParams.userId === undefined ? 1 : retParams.userId;
                    // retParams.roleId = retParams.roleId === undefined ? 30 : retParams.roleId;
                    // retParams.roleName = retParams.roleName === undefined ? '강사' : retParams.roleName;
                    //
                    // localStorage.setItem('userInfo', JSON.stringify( retParams ));
                    // //
                    //
                    // console.log('===> 로그인 성공');

                    const jwtObject = jwt_decode(response.data.accessToken);
                    const retParams = { ...jwtObject };

                    // console.log(
                    //     '=========== FIND data.centerChains ===================='
                    // );
                    // console.log(response.data, retParams);
                    // console.log('===============================');

                    retParams.accessToken = response.data.accessToken;
                    retParams.refreshToken = response.data.refreshToken;
                    retParams.centerId = retParams.cid;
                    retParams.userId = retParams.lid;
                    retParams.userName = retParams.unm;
                    retParams.roleId = retParams.rid;
                    retParams.roleName = retParams.rnm;
                    retParams.centerChains = response.data.centerChains;

                    // 메뉴 권한 초기화 : 센터에만 적용

                    // if (parseInt(retParams.centerId, 10) !== 0) {
                    //     const allowedMenuEvent = new AllowedMenuEvent();
                    //     allowedMenuEvent.init();
                    // }

                    return retParams;
                }
            })
            .catch((error) => {
                alert(error.response.data.message);
                throw error;
            });
    }

    loginCustomer(loginInfo) {
        return api
            .post('/admin/api/auth/customer/login', {
                ...loginInfo,
            })
            .then(this.handleResponse)
            .then((response) => {
                if (response.data.accessToken) {
                    const jwtObject = jwt_decode(response.data.accessToken);
                    const retParams = { ...jwtObject };

                    retParams.accessToken = response.data.accessToken;
                    retParams.refreshToken = response.data.refreshToken;
                    retParams.centerId = retParams.cid;
                    retParams.userId = retParams.lid;
                    retParams.userName = retParams.unm;
                    retParams.roleId = retParams.rid;
                    retParams.roleName = retParams.rnm;
                    retParams.centerChains = response.data.centerChains;

                    return retParams;
                }
            })
            .catch((error) => {
                alert(error.response.data.message);
                throw error;
            });
    }

    async logout(refreshToken) {
        if (refreshToken) {
            await api.delete(`/admin/api/auth/${refreshToken}`);
        }
        localStorage.removeItem('userMenu');
        localStorage.removeItem('menuEventCds');
    }

    switchCenter(centerId) {
        return api.post(`/admin/api/auth/center/${centerId}`)
            .then((response) => {
                if (response.status === 401 || response.status === 404) {
                    const error = response.data && response.data.message;
                    return Promise.reject(error);
                }

                if (response.data.accessToken) {
                    const jwtObject = jwt_decode(response.data.accessToken);
                    const retParams = { ...jwtObject };

                    retParams.accessToken = response.data.accessToken;
                    retParams.refreshToken = response.data.refreshToken;
                    retParams.centerId = retParams.cid;
                    retParams.userId = retParams.lid;
                    retParams.userName = retParams.unm;
                    retParams.roleId = retParams.rid;
                    retParams.roleName = retParams.rnm;
                    retParams.centerChains = response.data.centerChains;

                    return retParams;
                }
            })
            .catch((error) => {
                alert(error.response.data.message);
                return error;
            });
    }

    handleResponse(response) {
        if (response.status === 401 || response.status === 404) {
            this.logout();
            location.reload(true);

            const error = response.data && response.data.message;
            return Promise.reject(error);
        }

        return Promise.resolve(response);
    }
}

export default new AuthService();
